"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
const testimonials = [{
  id: 1,
  quote: "Grazie a Solid Dew RSL abbiamo ridotto il consumo idrico del 45% mantenendo una qualità del raccolto superiore. Un investimento fondamentale per il futuro della nostra azienda.",
  name: "Daniel D.\n",
  major: "Tunduqueral Green Village",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/farmer_marco_valenti.png"
}, {
  id: 2,
  quote: "L'integrazione di Biodust ha rigenerato i nostri terreni più aridi. Vedere le radici così forti in condizioni di siccità è stata una vera rivelazione tecnologica.",
  name: "Giulia B.",
  major: "Tenuta Le Querce",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/farmer_giulia_bianchi.png"
}, {
  id: 3,
  quote: "Solid Green Italia ci ha fornito non solo prodotti d'eccellenza, ma una consulenza tecnica che ha trasformato il nostro approccio alla sostenibilità idrica.",
  name: "Pietro R.",
  major: "Terre di Luce\n",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/farmer_pietro_romano.png"
}];
export default function StudentSuccessStories() {
  return <section data-section-id="234219" id="voci-dal-campo" className="bg-background text-foreground py-24 sm:py-32 overflow-hidden relative">
      {}
      <div className="absolute inset-0 pointer-events-none flex justify-center items-center opacity-20">
        <div className="w-[800px] h-[400px] bg-primary/20 blur-[120px] rounded-lg" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                <div className="flex flex-col items-center justify-center p-4 sm:p-8">
                  <blockquote className="text-2xl md:text-4xl font-serif text-center leading-relaxed text-foreground mb-10 max-w-4xl mx-auto tracking-tight italic">
                    "{testimonial.quote}"
                  </blockquote>
                  
                  <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
                    <div className="flex items-center gap-3">
                      <SafeHydrate><Avatar className="size-14 border-2 border-primary/20 shadow-md">
                        <AvatarImage src={testimonial.avatarUrl} alt={testimonial.name} />
                        <AvatarFallback className="bg-primary text-primary-foreground font-default">
                          {testimonial.name.split(" ").map(n => n[0]).join("")}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="flex flex-col items-start">
                        <span className="font-default font-bold text-foreground text-base">
                          {testimonial.name}
                        </span>
                      </div>
                    </div>
                    
                    <div className="hidden sm:block w-px h-8 bg-border" />
                    
                    <Badge variant="secondary" className="rounded-lg px-4 py-1.5 text-xs font-default font-semibold bg-white text-primary border-border shadow-lg">
                      {testimonial.major}
                    </Badge>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex items-center justify-center gap-3 mt-12">
            <CarouselPrevious className="static translate-y-0 translate-x-0 bg-white text-primary hover:bg-primary hover:text-white border-primary/20 shadow-md size-12 rounded-lg transition-colors" />
            <CarouselNext className="static translate-y-0 translate-x-0 bg-white text-primary hover:bg-primary hover:text-white border-primary/20 shadow-md size-12 rounded-lg transition-colors" />
          </div>
        </Carousel>
      </div>
    </section>;
}